module.exports = __webpack_public_path__ + "static/media/3 Children in Blue Jeans - Pastel.7e024c68.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/3 Children in Blue Jeans - Pastel.jpg
 ** module id = 382
 ** module chunks = 0
 **/